import { Routes } from '@angular/router';
import { CashFlowComponent } from '@pages/cash-flow/cash-flow.component';
import { CreditCardsComponent } from '@pages/credit-cards/credit-cards.component';
import { CreditCardSummaryComponent } from '@pages/credit-cards/credit-card-summary/credit-card-summary.component';
import { CreditLinesComponent } from '@pages/credit-lines/credit-lines.component';
import { DashboardFinanceComponent } from '@pages/dashboard-finance/dashboard-finance.component';
import { DesignSystemComponent } from '@pages/design-system/design-system.component';
import { InvestmentsComponent } from '@pages/investments/investments.component';
import { ComparativeReportsComponent } from '@pages/results/comparative-report/comparative-reports.component';
import { MonthlyReportsComponent } from '@pages/results/monthly-report/monthly-reports.component';
import { StatementComponent } from '@pages/statement/statement.component';
import { ValidationComponent } from '@pages/validation/validation.component';
import { authValidationGuard } from '@shared/guards/auth-validation.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard-finance',
    pathMatch: 'full',
  },
  {
    path: 'dashboard-finance',
    component: DashboardFinanceComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'design-system',
    component: DesignSystemComponent,
  },
  {
    path: 'cash-flow',
    component: CashFlowComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'cash-flow/list',
    component: StatementComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'results/monthly',
    component: MonthlyReportsComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'results/comparative',
    component: ComparativeReportsComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'investments',
    component: InvestmentsComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'credit-lines',
    component: CreditLinesComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'validation',
    component: ValidationComponent,
  },
  {
    path: 'credit-cards',
    component: CreditCardsComponent,
    canActivate: [authValidationGuard],
  },
  {
    path: 'credit-card-summary',
    component: CreditCardSummaryComponent,
    canActivate: [authValidationGuard],
  },
];
